import React from 'react'
import CompetitionResult from '../feature/LeaderBoard/CompetitionResult'

const CompetionResultPage = () => {
  return (
    <CompetitionResult/>
  )
}

export default CompetionResultPage
